import "./styles.scss";

import { useTranslation } from "react-i18next";

import Button from "components/Button";

const mainClass = "settings-layout-delete-account-mobile";

const DeleteAccountMobile = ({ name, onClick }) => {
  const { t } = useTranslation();

  return (
    <div className={mainClass}>
      <div className={`${mainClass}__header`}>
        <h6>{t("Delete account")}</h6>
        <p>
          {t("Are you sure you want to delete the account of")} "
          <strong>{name ?? "undefined"}</strong>"?{" "}
          <u>{t("This action cannot be undone")}</u>.
        </p>
      </div>
      <div className={`${mainClass}__cta`}>
        <Button onClick={onClick}>{t("Delete")}</Button>
      </div>
    </div>
  );
};

export default DeleteAccountMobile;
